"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.spendTableConf = void 0;
var CompanyTeamsSelect_1 = __importDefault(require("containers/MyStack/CompanyTeamsSelect"));
var constants_1 = require("containers/TableMaker/constants");
var dateTime_1 = require("utils/dateTime");
var constants_2 = require("./constants");
var LG = constants_1.CellSize.LG, MD = constants_1.CellSize.MD, SM = constants_1.CellSize.SM;
var lastNMonths = (0, dateTime_1.getLastNMonthStrings)(constants_2.N_MONTHS);
exports.spendTableConf = {
    headersMap: __assign({ serviceName: 'Tool', calculatedAnnualSpend: 'Spend (1Y)', companyTeams: 'Teams' }, Object.fromEntries(lastNMonths.map(function (month, idx) { return ["lastNMonthsExpenditures[".concat(idx, "]"), month]; }))),
    layout: {
        scrollToRight: true,
        fixedColumns: 3,
    },
    extractors: {
        serviceName: function (sS) { return sS.service.niceName || sS.service.name; },
        calculatedAnnualSpend: function (spend) { return spend.calculatedAnnualSpend || 0; },
    },
    cells: __spreadArray([
        {
            cell: { width: LG }, avatar: { size: 'xxs' }, truncate: {}, field: 'serviceName',
        },
        {
            cell: { width: LG, isFlexCenter: true }, field: 'companyTeams', renderComponent: CompanyTeamsSelect_1.default, stopPropagation: true,
        },
        {
            cell: { width: MD, hasBorderRight: true, offset: 'right' },
            field: 'calculatedAnnualSpend',
            footerAggregate: 'sum',
            money: { isRounded: true },
        }
    ], __read(lastNMonths.map(function (month, idx) { return ({
        cell: { width: SM + 10 },
        field: "lastNMonthsExpenditures[".concat(idx, "]"),
        footerAggregate: 'sum',
        money: { isRounded: true },
    }); })), false),
};
